var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header'),_c('router-view',{staticClass:"main"}),(_vm.r !== '/' && _vm.r !== '/challenge')?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }